import axios from 'axios';
import * as Sentry from '@sentry/react';

export default (packetId, title, phaseKey, newDate) =>
	axios
		.patch(
			`/jsonapi/node/packet/${packetId}`,
			{
				data: {
					type: 'node--packet',
					id: packetId,
					attributes: {
						created: { value: newDate },
						title: { value: title }
					}
				}
			},
			{
				headers: { Accept: 'application/vnd.api+json', 'Content-Type': 'application/vnd.api+json' }
			}
		)
		.catch(error => {
			Sentry.captureException(error);
			throw error;
		});
